/* Smile Kit – Oral Red Light page helpers: repeated add-to-cart uses the theme's main product form, so the cart drawer, apps and analytics keep working. */
(function(){
  if (window.__skrl) return; window.__skrl = true;
  var sleep = function(ms){ return new Promise(function(r){ setTimeout(r, ms); }); };
  function mainForm(){ return document.querySelector('form[data-type="add-to-cart-form"]'); }
  function mainId(){ var f = mainForm(); var i = f && f.querySelector('input[name="id"]'); return i ? i.value : null; }
  function mainButton(){ var f = mainForm(); return f && f.querySelector('button[name="add"]'); }
  async function selectVariant(value, id){
    if (!id || String(mainId()) === String(id)) return true;
    var input = Array.prototype.find.call(document.querySelectorAll('variant-picker input[type="radio"]'), function(i){ return i.value === value; });
    if (input) {
      // Select the matching option in the theme's own variant picker without jumping the page up to it.
      var x = window.scrollX, y = window.scrollY;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      window.scrollTo(x, y);
      await sleep(400);
      if (String(mainId()) !== String(id)) { var lab = input.closest('label'); (lab || input).click(); window.scrollTo(x, y); }
      requestAnimationFrame(function(){ window.scrollTo(x, y); });
    }
    var t = Date.now();
    while (Date.now() - t < 5000) { if (String(mainId()) === String(id)) return true; await sleep(100); }
    return String(mainId()) === String(id);
  }
  function go(id){
    var t = document.getElementById(id), block = 'start';
    if (!t && id === 'sk-buy') { t = document.querySelector('variant-picker') || mainForm(); block = 'center'; }
    if (!t) return false;
    t.scrollIntoView({behavior:'smooth', block: block}); return true;
  }
  async function add(btn, value, id, msgEl){
    btn.disabled = true;
    try {
      var ok = await selectVariant(value, id);
      var b = mainButton();
      if (ok && b && !b.disabled) { b.click(); if (msgEl) msgEl.textContent = (value ? value + ' ' : '') + 'added to your cart'; }
      else go('sk-buy');
    } finally { setTimeout(function(){ btn.disabled = false; }, 1200); }
  }
  document.addEventListener('click', function(e){
    var sw = e.target.closest('.skrl-sw');
    if (sw && !sw.disabled) {
      var box = sw.closest('[data-skrl-buy]');
      box.querySelectorAll('.skrl-sw').forEach(function(s){ s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); });
      box.dataset.value = sw.dataset.value; box.dataset.id = sw.dataset.id;
      var name = box.querySelector('[data-skrl-colour]'); if (name) name.textContent = sw.dataset.value;
      var img = box.querySelector('[data-skrl-img]'); if (img && sw.dataset.img) { img.src = sw.dataset.img; img.removeAttribute('srcset'); }
      var price = box.querySelector('[data-skrl-price]'); if (price && sw.dataset.price) price.innerHTML = sw.dataset.price;
      return;
    }
    var atc = e.target.closest('[data-skrl-atc]');
    if (atc) {
      e.preventDefault();
      var box2 = atc.closest('[data-skrl-buy]');
      if (box2) add(atc, box2.dataset.value, box2.dataset.id, box2.querySelector('.skrl-buy__msg'));
      else { var b = mainButton(); if (b && !b.disabled) b.click(); else go('sk-buy'); }
    }
    var jump = e.target.closest('[data-skrl-jump]');
    if (jump) { if (go(jump.getAttribute('data-skrl-jump'))) e.preventDefault(); }
  });
  // Sticky bar on mobile: show once the main buy button has scrolled out of view.
  function initSticky(){
    var bar = document.querySelector('.skrl-sticky'); var b = mainButton();
    if (!bar || !b || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('.skrl-hero');
    var seenBuy = false;
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { seenBuy = true; bar.classList.remove('is-on'); }
        else if (seenBuy && en.boundingClientRect.top < 0) bar.classList.add('is-on');
        else bar.classList.remove('is-on');
      });
    }).observe(b.closest('add-to-cart-component') || b);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
})();
